import React from "react";

const PaymentRejected = () => {
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
  return (
    <div
      className="container d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "80vh" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        fill="none"
        viewBox="0 0 24 24"
        stroke="red"
        strokeWidth="2"
        className="mb-4"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>

      <h1 className="display-5 fw-bold text-danger mb-3">Payment Failed</h1>
      <p className="lead text-muted">
        Unfortunately, your transaction was not successful. Please try again or
        contact support.
      </p>
    </div>
  );
};

export default PaymentRejected;